import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

import { transformSource } from '../../utils/helpers';
import './Statistics.sass';

import { ReactComponent as DudeRed } from '../../assets/img/dude/dude-red.svg';
import { ReactComponent as DudeBlue } from '../../assets/img/dude/dude-blue.svg';

interface Props {
	statistic: { value: string; text: string }[];
}

function Statistics(props: Props) {
	const { statistic } = props;
	return (
		<section className="statistics">
			<Container>
				<Row>
					<Col xs={12} xl={10} className="statistics__inner">
						{statistic.map((stat, index) => (
							<>
								<div
									// eslint-disable-next-line react/no-array-index-key
									key={index}
									className="statistics__item statistics-item"
								>
									<div className="statistics-item__num">{stat.value}</div>
									<div className="statistics-item__value">
										{ReactHtmlParser(stat.text, {
											transform: transformSource,
										})}
									</div>
								</div>
								{index === 2 ? (
									<div
										// eslint-disable-next-line react/no-array-index-key
										key={`${index}-icon`}
										className="statistics__item statistics-item"
									>
										<DudeRed className="statistics-item__dude" />
									</div>
								) : null}
								{index === 4 ? (
									<div
										// eslint-disable-next-line react/no-array-index-key
										key={`${index}-icon`}
										className="statistics__item statistics-item"
									>
										<DudeBlue className="statistics-item__dude" />
									</div>
								) : null}
							</>
						))}
					</Col>
				</Row>
			</Container>
		</section>
	);
}

export default Statistics;
